import { makeStyles } from 'lib/components';

export default makeStyles((theme) => {
  const chipColors = [
    {
      background: theme.evPalette.ocean[200],
      color: theme.evPalette.ocean[800],
    },
    {
      background: theme.evPalette.mango[100],
      color: theme.evPalette.mango[900],
    },
    {
      background: theme.evPalette.lime[100],
      color: theme.evPalette.lime[900],
    },
    {
      background: theme.evPalette.raspberry[100],
      color: theme.evPalette.raspberry[900],
    },
  ];

  return ({
    propertyDetails: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '460px',
      padding: '16px 24px',
      borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
      gap: '24px',
      '&.blueprint': {
        minHeight: '0px',
        '@media (min-width: 640px)': {
          minHeight: '0px',
        },
      },
      '@media (min-width: 640px)': {
        minHeight: '300px',
        flexDirection: 'row',
      },
    },
    mapContainer: {
      height: '300px',
      width: '50%',
      '@media (max-width: 640px)': {
        width: '100%',
        columnGap: '8px',
      },
    },
    propertyDetailsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      flex: 1,
    },
    propertyTypeHeading: {
      '& >.myev-MuiFormLabel-asterisk': {
        color: theme.evPalette.rose[900],
      },
    },
    buildingDetails: {
      padding: '8px',
      columnGap: '8px',
      rowGap: '16px',
      '&.focused': {
        backgroundColor: theme.evPalette.ocean[700],
        '& p': { color: `${theme.evPalette.salt[100]} !important` },
        borderRadius: '4px',
        border: 'none',
      },
    },
    buildingIdChip: {
      ...chipColors.reduce((styles, currStyle, index) => ({ ...styles, [`&.index-${index}`]: currStyle }), {}),
      borderRadius: '12px',
      alignItems: 'center',
      height: '18px',
      padding: '2px 8px',
      minWidth: '23px',
      margin: '0 6px',
      '& >span': { padding: 0 },
    },
    checkChangesContainer: {
      columnGap: '8px',
      padding: '6px',
    },
    checkChanges: {
      padding: 0,
    },
    changesIn4YearsLabel: {
      color: theme.evPalette.charcoal[900],
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '18px',
      letterSpacing: '0px',
    },
  });
});
